import React, { FC, memo } from 'react'

import { Button, IconButton, styled } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Title from './Title'
import { useLocalizedText } from '../../context/Localization/localizationHooks';
import { LocalizedText } from '../../context/Localization/LocalizationTypes';

const RootContainer = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '24px',
}))

const RightOptionsContainer = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'space-between',
}))

const DeleteButtonContainer = styled(Button)(() => ({
    color: '#5B6971',
    textTransform: 'capitalize',
    fontSize: 13,
    fontWeight: 400,
}))

const ChevronButtonContainer = styled(IconButton)(() => ({
    color: '#263238',
}))

export interface GroupConditionHeaderProps {
    label: string
    expanded: boolean
    showDelete: boolean
    onCollapse: () => void
    onExpand: () => void
    onDeleteGroupCondition: () => void
}

const Header: FC<GroupConditionHeaderProps> = (props) => {
    const DELETE_GROUP_CONDITION = useLocalizedText(LocalizedText.DeleteGroupCondition)

    const handleDeleteGroupCondition: React.MouseEventHandler<HTMLButtonElement> = (event) => {
        event.stopPropagation()
        props.onDeleteGroupCondition()
    }

    return (
        <RootContainer onClick={props.expanded ? props.onCollapse : props.onExpand}>
            <Title label={props.label} />
            <RightOptionsContainer>
                { props.showDelete && (
                    <DeleteButtonContainer variant="text" startIcon={<DeleteIcon />} onClick={handleDeleteGroupCondition}>
                        {DELETE_GROUP_CONDITION}
                    </DeleteButtonContainer>
                ) }
                { props.expanded ? (
                    <ChevronButtonContainer color="primary" aria-label="upload picture" onClick={props.onCollapse}>
                        <ExpandLessIcon />
                    </ChevronButtonContainer>
                ) : (
                    <ChevronButtonContainer color="primary" aria-label="upload picture" onClick={props.onExpand}>
                        <ExpandMoreIcon />
                    </ChevronButtonContainer>
                ) }
            </RightOptionsContainer>
        </RootContainer>
    )
}

export default memo(Header)